import axios from 'axios';
import cookies from 'js-cookie';
import { cookieNames } from '~constants/storage';
import { communicationStatus } from '~constants';

export const isNetworkIssue = error =>
  error.message &&
  (error.message.indexOf('timeout') !== -1 || error.message.indexOf('Network') !== -1);

export const updateCommunicationStatus = ({ actionType, application, status, error = {} }) => ({
  type: actionType,
  application,
  status,
  error,
});

export const handleFetchCatch = ({ actionType, dispatch, application, error }) => {
  if (isNetworkIssue(error)) {
    dispatch(
      updateCommunicationStatus({
        actionType,
        application,
        status: communicationStatus.TIMEOUT,
      }),
    );
  } else {
    dispatch(
      updateCommunicationStatus({
        actionType,
        application,
        status: communicationStatus.CLIENT_ERROR,
      }),
    );
  }
};

export const fetch = ({
  endpoint,
  params = {},
  successAction,
  communicationType = null,
  dispatch = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  if (communicationType && dispatch) {
    dispatch(
      updateCommunicationStatus({
        actionType: communicationType,
        status: communicationStatus.FETCHING,
      }),
    );
  }

  axios({
    method: 'post',
    url: endpoint,
    data: params,
    headers: {
      Authorization: cookies.get(cookieNames.token)
        ? `Bearer ${cookies.get(cookieNames.token)}`
        : '',
      'Current-Role': 'landlord',
    },
  })
    .then(response => {
      if (response.data.data && response.data.errors) {
        if (communicationType && dispatch) {
          dispatch(
            updateCommunicationStatus({
              actionType: communicationType,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        }
        onError(response.data.errors, response?.data?.errors?.[0]?.extensions?.code);
      } else if (typeof response.data.errors === 'undefined' && response.data.data) {
        if (successAction && dispatch) {
          dispatch(successAction(response.data.data));
        }
        if (communicationType && dispatch) {
          dispatch(
            updateCommunicationStatus({
              actionType: communicationType,
              status: communicationStatus.IDLE,
            }),
          );
        }
        onSuccess(response.data.data);
      } else if (communicationType && dispatch) {
        dispatch(
          updateCommunicationStatus({
            actionType: communicationType,
            status: communicationStatus.ERROR,
            error: response.data.errors,
          }),
        );
      }
    })
    .catch(error => {
      if (communicationType && dispatch) {
        handleFetchCatch({
          actionType: communicationType,
          dispatch,
          error,
        });
      }

      onError(error);
    });
};
